module.exports = "dist/images/components-design-separator-control-rounded-2.e6d5edc.png";